function isNull(object) {
  if (object == null || typeof object == "undefined") {
    return true;
  }
  return false;
}

function removeRem() {
  var doc = window.document;
  var docEl = doc.documentElement;
  docEl.removeAttribute('style');
}
export default {
  isIE: () => {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
    return (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident")>-1);
  },
  isMobile: () => {
    return (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i));
  },
  refreshRem: () => {
    var doc = window.document;
    var docEl = doc.documentElement;
    var width = docEl.getBoundingClientRect().width;
    //如果是pc
    if (width > 540) {
      removeRem();
      return;
    }
    if (width > 540) { // 最大宽度
      width = 540;
    }
    var rem = width / 3.75; // iPhone6比例
    docEl.style.fontSize = rem + 'px';
    window.__REM__ = rem;
  },
  getParam: (n, t) => {
    var i = new RegExp('(?:^|\\?|#|&)' + n + '=([^&#]*)(?:$|&|#)', 'i'),
      o = i.exec(t || location.href);
    return o ? decodeURIComponent(o[1]) : '';
  },
  getSystemPlatform() {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return 'iOS';
    } else if (/(Android)/i.test(navigator.userAgent)) {
      return 'Android';
    } else {
      return 'PC';
    }
  },
  sum(arr) {
    let val;
    if (arr && arr.length == 0) {
      val = 0;
    } else if (arr && arr.length == 1) {
      val = arr[0];
    } else {
      val = parseFloat(arr[0]) + parseFloat(this.sum(arr.slice(1)));
    }
    return Number(val).toFixed(2);
  },
  getWeek(dateString) {
    var date;
    if (isNull(dateString)) {
      date = new Date();
    } else {
      var dateArray = dateString.split("-");
      date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
    }
    return "星期" + "日一二三四五六".charAt(date.getDay());
  },
  getCurrentDate() {
    const now = new Date();
    const year = now.getFullYear(); //年
    const month = now.getMonth() + 1; //月
    const day = now.getDate(); //日
    return `${year}-${month}-${day}`;
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js